import { errorCallback, makeUrl } from "../../constant";
import { GET_PRODUCT_BY_ID, GET_PRODUCT_SEARCH, getFetchRequest } from "../../store/requests";

export const GET_IMAGE_TIMEOUT = 200;

export const hintsService = {
    searchInputValue: "",
    listOfHints: [],
    globalSearchHistory: [],
    observersList: [],
    globalHistoryObservers: [],
    lastActionTime: "",
    searchTimeout: null,
    MAX_HISTORY: 4,
    SEARCH_HISTORY_KEY: "searchHistory",

    setSearchValue(searchValue) {
        this.searchInputValue = searchValue;
        this.lastActionTime = Date.now();
        clearTimeout(this.searchTimeout);
        this.searchTimeout = setTimeout(() => {
            this.makeHintsSearch();
        }, 300);
    },

    getSearchValue() {
        return this.searchInputValue;
    },

    makeHintsSearch() {
        try {
            if (this.searchInputValue.length > 2) {
                getFetchRequest(
                    makeUrl([GET_PRODUCT_SEARCH, `hint/?q=${this.searchInputValue}`]),
                    (response) => {
                        this.listOfHints = Array.isArray(response) ? response.slice(0, 4) : [];
                        this.notifyHintsObservers();
                    },
                    errorCallback,
                );
            }
        } catch (err) {
            console.log(err);
        }
    },

    fetchGlobalSearchHistory() {
        getFetchRequest(
            makeUrl(["/api/v1/product/search/history"]),
            (response) => {
                this.globalSearchHistory = Array.isArray(response) ? response : [];
                this.notifyGlobalHistoryObservers();
            },
            errorCallback,
        );
    },

    storeSearchQuery(query) {
        return new Promise((resolve, reject) => {
            try {
                const encodedQuery = encodeURIComponent(query);
                const url = makeUrl([`/api/v1/product/search/history/store?query=${encodedQuery}`]);
                getFetchRequest(
                    url,
                    () => resolve(),
                    (error) => {
                        errorCallback(error);
                        reject(error);
                    },
                );
            } catch (e) {
                reject(e);
            }
        });
    },

    saveSearchHistory(query) {
        return new Promise((resolve) => {
            if (!query || query.length < 3) return resolve();

            let history = this.getSearchHistory();
            history = [query, ...history.filter((item) => item !== query)];
            if (history.length > this.MAX_HISTORY) {
                history = history.slice(0, this.MAX_HISTORY);
            }

            localStorage.setItem(this.SEARCH_HISTORY_KEY, JSON.stringify(history));
            resolve();
        });
    },

    getSearchHistory() {
        return JSON.parse(localStorage.getItem(this.SEARCH_HISTORY_KEY)) || [];
    },

    registerHintsObserver(observer) {
        this.observersList.push(observer);
    },

    unRegisterHintsObserver(observer) {
        this.observersList = this.observersList.filter((observerItem) => observerItem !== observer);
    },

    notifyHintsObservers() {
        this.observersList.forEach((observer) => observer(this.listOfHints));
    },

    registerGlobalHistoryObserver(observer) {
        this.globalHistoryObservers.push(observer);
    },

    unRegisterGlobalHistoryObserver(observer) {
        this.globalHistoryObservers = this.globalHistoryObservers.filter((observerItem) => observerItem !== observer);
    },

    notifyGlobalHistoryObservers() {
        this.globalHistoryObservers.forEach((observer) => observer(this.globalSearchHistory));
    },

    changeLastActionTime(lastActionTime) {
        this.lastActionTime = lastActionTime;
    },

    getHintImage(productId, callback) {
        if (Date.now() - this.lastActionTime > GET_IMAGE_TIMEOUT) {
            getFetchRequest(
                makeUrl([GET_PRODUCT_BY_ID, `${productId}/?onlyImage=true`]),
                (response) => {
                    const currentProductIndex = this.listOfHints.findIndex((it) => it.productId === productId);
                    if (currentProductIndex >= 0) {
                        this.listOfHints[currentProductIndex].images = response;
                    }
                    callback && callback(response);
                },
                errorCallback,
            );
        }
    },

    clearHintsList() {
        this.listOfHints = [];
        this.notifyHintsObservers();
    },

    async getProductsCount() {
        try {
            const url = makeUrl(["/api/v1/product/count/"]);
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            return data.count;
        } catch (error) {
            console.error("Ошибка при получении количества товаров:", error);
            return null;
        }
    },
};

